export enum RecordStatus {
    Added = 0,
    Updated = 1,
    Deleted = 2,
    NotFound = 3,
    AlreadyDeleted = 4,
    ReferenceExist = 5,
    NoContent = 6,
    Failed = 7
}

export enum Operation {
    Add = 0,
    Update = 1,
    Delete = 2,
    Get = 3,
    ExportTemplate = 4,
    BulkImport = 5
}

export enum ImportExportStatusCodes {
    PartiallyAdded = 0,
    AllAdded = 1
}